/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import { IconButton } from "@material-ui/core";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import CustomYesNoModal from "../micro_components/CustomYesNoModal";
import { useEffect } from "react";
import ChapterDataService from "../../services/ChapterService";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import Button from "@material-ui/core/Button";
import PageModalV2 from "./PageModalV2";

// const ReactDragListView = require("react-drag-listview");

import ReactDragListView from "react-drag-listview";

const ChapterList = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { bookId, initialChapters, deleteChapter, setChapters } = props;
  const [orderChanged, setOrderChanged] = useState(false);
  const [chapters, setLocalChapters] = useState(initialChapters);

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...chapters];
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      setOrderChanged(true);
      console.log("Chapters: ", data);
      data.forEach((c, i) => (c.order_index = i));
      setChapters(data);
      setLocalChapters(data);
      // that.setState({ data });
    },
    nodeSelector: "li",
    handleSelector: "a",
  };

  const saveChapterOrder = () => {
    console.log("saving: ", chapters);
    ChapterDataService.updateChapters(chapters)
      .then(() => {
        console.log("saved chapter order");
        setOrderChanged(false);
      })
      .catch((e) => console.log("could not save chapters"));
  };

  const setIndividualChapter = (data) => {
    let rep = chapters;
    let chapterToUpdate = chapters.find((c) => c.id === data.id);
    let i = chapters.indexOf(chapterToUpdate);
    rep[i] = data;
    setChapters(rep);
    setLocalChapters(rep);
  };

  useEffect(() => {
    // console.log("CHAPTERS getting change: ", chapters);
  });

  return (
    <div style={{ padding: "0 20px" }}>
      {/* {JSON.stringify(chapters)} */}
      <ReactDragListView {...dragProps}>
        <ul
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {chapters.map((chapter, index) => {
            return (
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "60%",
                  minWidth: "400px",
                }}
                key={chapter.id}
              >
                <ChapterCard
                  chapter={chapter}
                  key={chapter.id}
                  bookId={bookId}
                  deleteChapter={deleteChapter}
                  setChapter={setIndividualChapter}
                />
                <a href="#">
                  {" "}
                  <IconButton
                    aria-label="create"
                    onClick={() => {
                      console.log("start dragging");
                    }}
                  >
                    <DragIndicatorIcon fontSize="large" />
                  </IconButton>
                </a>
              </li>
            );
          })}
        </ul>
      </ReactDragListView>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {orderChanged && (
          <>
            <Button color="primary" onClick={saveChapterOrder}>
              Save Order
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ChapterList;

const ChapterCard = (props) => {
  //delete chapter and chapter form parent
  const { chapter, deleteChapter, bookId } = props;
  //is delete modal open?
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  //is page modal open?
  const [pageModalOpen, setPageModalOpen] = useState(false);

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = (id) => {
    deleteChapter(id);
    setIsDeleteModalOpen(false);
  };

  const openPageModal = () => {
    console.log(chapter);
    setPageModalOpen(true);
  };
  const closePageModal = () => {
    setPageModalOpen(false);
  };

  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#fff",
        boxShadow: "0 0 0.25em 0.12em rgba(0, 0, 0, 0.2)",
        paddingLeft: "20px",
        flexGrow: "1",
        margin: "8px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <h5>{chapter.name}</h5>
      </div>
      <div style={{ marginLeft: "auto", display: "flex" }}>
        <IconButton aria-label="create" onClick={openPageModal}>
          <MenuBookIcon fontSize="large" color="primary" />
        </IconButton>
        <IconButton aria-label="create" onClick={openDeleteModal}>
          <DeleteRoundedIcon fontSize="large" color="secondary" />
        </IconButton>
      </div>
      <div>
        <CustomYesNoModal
          title={"Are you sure you want to delete " + chapter.name + "?"}
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onSubmit={() => confirmDelete(chapter.id)}
          initial={""}
        />
        <PageModalV2
          chapterId={chapter.id}
          bookId={bookId}
          isOpen={pageModalOpen}
          onClose={closePageModal}
          initialChapter={chapter}
        />
      </div>
    </div>
  );
};
